export const isValidReportingCode = (value: string) =>
  value && /^[X0-9]{3}[0-9]{1}$/.test(value) ? undefined : 'global.not_a_valid_reporting_code'
